
import Vue from 'vue';
import { transformLink, TransformLinkReturn } from '~/transforms/transformComponents';
import { trackTeaserClick } from '~/utility/tracking';

export default Vue.extend({
  props: {
    image: {
      type: Object,
    },
    headline: {
      type: String,
    },

    link: {
      type: Object,
    },
    linkLabel: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
  },
  computed: {
    linkData(): TransformLinkReturn {
      return transformLink(this.link, this.linkLabel);
    },
  },
  methods: {
    handleTeaserClick(event: MouseEvent): void {
      if (process.client && this.linkData) {
        trackTeaserClick(this.headline, this.linkData.url);
      }
    },
  },
});
